import React from 'react'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import Badge, { BadgeProps } from '@mui/material/Badge'
import { useNavigate } from 'react-router-dom'

const ActionButton = ({ color, url, icon, tooltip, badge }) => {
  const navigate = useNavigate()
  return (
    <Tooltip title={tooltip}>
      <Badge badgeContent={badge} color="contrast">
        <IconButton
          color="secondary"
          onClick={() => navigate(url)}
          sx={{
            backgroundColor: '#c5caca',
            borderRadius: 1,
            border: 'solid 1px',
            borderColor: 'secondary.main',
          }}
        >
          {icon}
        </IconButton>
      </Badge>
    </Tooltip>
  )
}

export default ActionButton
